import useOverlay from "@/hooks/common/useOverlay";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/detailpackage/productinformation";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {PlusMoreButton} from "@FRAMEWORK/ui/desktop/button";
import {EditorBox} from "@FRAMEWORK/ui/desktop/editor";
import {PopupContainer} from "@FRAMEWORK/ui/desktop/popup";
import {SubTitle} from "@FRAMEWORK/ui/desktop/text";
import useEventNotice from "@QUERIES/prdt/event/useEventNotice";
import {useEffect, useState} from "react";
import ReactPlayer from "react-player";
import HotelResort from "./HotelResort";

const GoodsInformationComponent = ({goodsInfo}: {goodsInfo: string}) => {
	const [showMore, setShowMore] = useState(false);
	const [activeButton, setActiveButton] = useState(false);
	const elementHeight = showMore ? "auto" : "800px";
	const buttonText = showMore ? "닫기" : "더 보기";

	const handleButton = () => {
		setShowMore(!showMore);
		if (showMore) {
			const $goodsWrap = document.querySelector("#__goodsWrap") as HTMLDivElement;
			// 140 fixed tab 보정치... 나중에 수정필요..
			const $target = $goodsWrap.getBoundingClientRect().top + window.scrollY - 140;
			window.scrollTo({top: $target, behavior: "smooth"});
		}
	};

	useEffect(() => {
		setTimeout(() => {
			const $goodsInfo = document.querySelector("#__goodsInfo") as HTMLDivElement;
			if ($goodsInfo.getBoundingClientRect().height >= 800) {
				setActiveButton(true);
			} else {
				setActiveButton(false);
			}
		}, 500);
	}, []);

	return (
		<>
			<style.EditorWrap elementHeight={elementHeight} id={"__goodsWrap"}>
				<EditorBox dangerouslySetInnerHTML={{__html: goodsInfo}} id={"__goodsInfo"} />
			</style.EditorWrap>
			{activeButton && <PlusMoreButton onClick={handleButton}>상품 안내 {buttonText}</PlusMoreButton>}
		</>
	);
};

// 상품안내
const GoodsInformation = (props: {goodsInfo: string}) => (
	<ErrorBoundary logMsg="Information GoodsInformation Error">
		<GoodsInformationComponent {...props} />
	</ErrorBoundary>
);

const InformationComponent = ({evCd}: {evCd: string}) => {
	const [playing, setPlaying] = useState(false);
	const noticeFetch = useEventNotice(evCd);
	const notice = noticeFetch.data?.body;

	const [open] = useOverlay();
	const handleSearcharge = e => {
		e.preventDefault();
		open(overlay => (
			<PopupContainer {...overlay} title="SURCHARGE 안내" size="large">
				<img src={`${publicRuntimeConfig.ENV_CIMG_CDN_URL}${notice.stretAttaFileKey}`} alt="써차지" />
			</PopupContainer>
		));
	};

	return (
		<>
			{notice && (
				<>
					{notice.vimeoUrl && (
						<style.PlayBox>
							<ReactPlayer
								url={notice.vimeoUrl}
								width="100%"
								height="100%"
								playing={playing}
								onPlay={() => setPlaying(true)}
								onPause={() => setPlaying(false)}
								volume={0}
								muted={true}
								controls
							/>
						</style.PlayBox>
					)}
					{/* 핵심 정보 이미지 */}
					{notice.keyInfoImageList.length > 0 &&
						notice.keyInfoImageList.map((item, index) => (
							<style.ImgEditor key={index}>
								<img src={`${publicRuntimeConfig.ENV_CIMG_CDN_URL}${item.pcAttaFilePath}`} alt="핵심정보 이미지" />
							</style.ImgEditor>
						))}
					{/* 호텔/리조트 */}
					<HotelResort evCd={evCd} />
					{(notice.stretAttaFileKey || notice.goodsInfo) && (
						<style.SubTitleWrap>
							<SubTitle>상품안내</SubTitle>
						</style.SubTitleWrap>
					)}
					{/* 서차지 */}
					{notice.stretAttaFileKey && (
						<style.SurchargeBox>
							<a href="#" onClick={handleSearcharge}>
								<img
									src="https://cimgcdn.ybtour.co.kr/promotion/etc/@sample/@sample_surcharge.jpg"
									alt="SURCHARGE 이미지"
								/>
							</a>
						</style.SurchargeBox>
					)}
					{notice.goodsInfo && <GoodsInformation goodsInfo={notice.goodsInfo} />}
				</>
			)}
		</>
	);
};

// subTab 핵심정보
const Information = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="Information Error">
		<InformationComponent {...props} />
	</ErrorBoundary>
);

export default Information;
